import { useEffect, useState } from "react";

import { deleteComponents } from "../../../api/components";
import { restoreComponents } from "../../../api/trash";

export const useTrashComponents = (components) => {
  const [componentsPicked, setComponentsPicked] = useState([]);
  const [selectedAllComponents, setSelectedAllComponents] = useState(false);

  const handlePickedComponent = (component) => {
    setComponentsPicked((prev) => {
      if (prev.includes(component.id)) {
        return prev.filter((id) => id !== component.id);
      }
      return [...prev, component.id];
    });
  };

  const handlePickedAllComponents = () => {
    if (selectedAllComponents) {
      setComponentsPicked([]);
    } else {
      setComponentsPicked(components.map((attribute) => attribute.id));
    }
  };

  const handleRestoreComponents = async () => {
    if (componentsPicked.length) {
      await restoreComponents({ componentIds: componentsPicked });
    }

    setComponentsPicked([]);
    setSelectedAllComponents(false);
  };

  const handleDeleteComponents = async () => {
    if (componentsPicked.length) {
      await deleteComponents({ componentIds: componentsPicked });
    }

    setComponentsPicked([]);
    setSelectedAllComponents(false);
  };

  useEffect(() => {
    if (componentsPicked?.length === components?.length && components?.length > 0) {
      setSelectedAllComponents(true);
    } else {
      setSelectedAllComponents(false);
    }
  }, [componentsPicked]);

  return {
    componentsPicked,
    selectedAllComponents,

    handlePickedComponent,
    handlePickedAllComponents,
    handleRestoreComponents,
    handleDeleteComponents,
  };
};
